export default {
  MESSAGE_NOPE: 'MESSAGE_NOPE',
  _UI_STATE_CHANGED: '_UI_STATE_CHANGED',
  _LOGIN_STATE_CHANGED: '_LOGIN_STATE_CHANGED',
  _PRIMITIVE_LOADED: '_PRIMITIVE_LOADED',
  _TOOL_CHANGED: '_TOOL_CHANGED',
  _PROJECT_CHANGED: '_PROJECT_CHANGED',
  _PROJECT_LOAD_FAIL: '_PROJECT_LOAD_FAIL',
  _PROJECT_LOAD_COMPLETE: '_PROJECT_LOAD_COMPLETE',
  _NEW_POINT: '_NEW_POINT',
  _SELECTION_CHANGED: '_SELECTION_CHANGED',
  _SELECTION_DID_UPDATE: '_SELECTION_DID_UPDATE',
  _SELECTION_DID_ROTATE: '_SELECTION_DID_ROTATE',
  _PROJECT_PROP_CHANGED: '_PROJECT_PROP_CHANGED',
  _POINT_REMOVED: '_POINT_REMOVED',
  _GET_SVG_LAYER: '_GET_SVG_LAYER',
  _LAYER_CALCULATED: '_LAYER_CALCULATED',
  _PROJECT_SAVE_CUSTOM_DATA: '_PROJECT_SAVE_CUSTOM_DATA',
  _HIDE_DATA_LAYER: '_HIDE_DATA_LAYER',
  _SHOW_DATA_LAYER: '_SHOW_DATA_LAYER',
  _START_RULLER_CALIBRATION: '_START_RULLER_CALIBRATION',
  _RULLER_CALIBRATION_INTERMEDATE: '_RULLER_CALIBRATION_INTERMEDATE',
  _RULLER_CALIBRATION_COMMIT: '_RULLER_CALIBRATION_COMMIT',
  _RULLER_CALIBRATION_APPLY: '_RULLER_CALIBRATION_APPLY',
  _RULLER_PRESET_CHANGED: '_RULLER_PRESET_CHANGED',
  _RULLER_STATUS: '_RULLER_STATUS',
  _RULLER_CLEAR: '_RULLER_CLEAR',
  _RULLER_STATUS_CHANGED: '_RULLER_STATUS_CHANGED',
  _RULLER_ACTIVATE: '_RULLER_ACTIVATE',
  //
  MESSAGE_DUMMY_EVENT: 'MESSAGE_DUMMY_EVENT',

  _WALL_ACTIVATE: '_WALL_ACTIVATE',
  _WALL_DEACTIVATE: '_WALL_DEACTIVATE',
  _WALL_CLEAR: '_WALL_CLEAR',
  _WALL_STATUS_CHANGED: '_WALL_STATUS_CHANGED',
  _GET_WALL_LAYER: '_GET_WALL_LAYER',
  _WALL_PREFERENCES_CHANGED: '_WALL_PREFERENCES_CHANGED',
  _WALL_UPDATE_DATA: '_WALL_UPDATE_DATA',
  _WALL_GET_WALLS_FROM_PROJECT: '_WALL_GET_WALLS_FROM_PROJECT',
  _WALL_GET_DATA_HOT_RELOAD: '_WALL_GET_DATA_HOT_RELOAD',
}
